/**
 * What the journey design's cover shows: its photo and the trip's numbers.
 *
 * Plain functions, so they run under plain node (tests/unit/journeyHighlights.test.js).
 * The stops themselves are the poster's (buildPosterStops in posterStops.js),
 * so both designs agree on how a trip is cut into stops.
 */

// The cover photo: the manager's top-of-page image, else the first stop that
// has a photo, else null (the cover then draws its gradient alone).
function journeyCover(ride, stops) {
  if (ride && ride.top_page_image_url) return ride.top_page_image_url;
  const withPhoto = (stops || []).find(stop => stop && stop.photo);
  return withPhoto ? withPhoto.photo : null;
}

// The numbers on the cover: days, and the places to visit -- each named place
// once, however many days it is on (by id, else by its name).
function journeyStats(attractionsByDay) {
  const days = attractionsByDay || [];
  const places = new Set();
  days.forEach(day => {
    ((day && day.daily_attractions) || []).forEach(attraction => {
      if (!attraction) return;
      const title = (attraction.title || '').trim();
      if (attraction.id) places.add(`id:${attraction.id}`);
      else if (title) places.add(`title:${title.toLowerCase()}`);
    });
  });
  return { days: days.length, places: places.size };
}

module.exports = { journeyCover, journeyStats };
